import CrudRepository from './CrudRepository'
export default class ChangeOfferStatusRepository extends CrudRepository {
  constructor () {
    super('core/api/specialOffers/changeState')
  }
}
